import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Login from "./components/Login";
import Features from "./components/Features";
import FeaturePaymentSuccess from "./components/FeaturePaymentSuccess";
import ValidateAppLogin from "./components/ValidateAppLogin";
import { isAuthenticated } from './utils/common_functions'

const App = () => {

    let logged_id = isAuthenticated();

    return (
        <div>
            <Routes>
                <Route exact path="/" element={<Login />} />
                <Route exact path="/login" element={<Login />} />
                <Route exact path="/validate_login" element={<ValidateAppLogin />} />
                <Route exact path="/features" element={logged_id ? <Features /> : <Navigate to="/login" />} />
                <Route exact path="/features-payment-success" element={logged_id ? <FeaturePaymentSuccess /> : <Navigate to="/login" />} />
            </Routes>
        </div>
    );
}

export default App;
